import React from 'react';
import YouTube from 'react-youtube';
const YoutubePlayer = _ref => {
  let {
    videoId
  } = _ref;
  return /*#__PURE__*/React.createElement(YouTube, {
    className: "embed-responsive-item",
    videoId: videoId
  });
};
export { YoutubePlayer };